import { externalAuthHeaderName } from 'api/apiReqSagaCreator/config';
import {
  WithExternalFormId,
  WithFieldId,
  WithReleaseOrDraftProcessId,
} from 'api/types/pathParams';
import ApiUrlParams from 'constants/apiUrlParams';

import { API_REQ_ACTION_TYPES } from '../actions';
import apiReqSagaCreator from '../apiReqSagaCreator';
import { ApiPaths, CONTENT_TYPE, HTTP_METHODS } from '../constants';

const { REACT_APP_API_DOCUMENT_SERVICE: documentServiceUrl } = import.meta.env;

interface SubmitParams {
  params: DynamicFormNormalizedParams;
  token: string;
}

interface UploadFileData {
  field: FormData;
}

type SubmitResult = unknown;
export type ResendParams = WithExternalFormId;
export type ResendResult = unknown;
type UploadFileParams = WithReleaseOrDraftProcessId &
  WithFieldId & { token: string } & UploadFileData;
type UploadFileResult = { url: string };

const External = {
  form: {
    submit: apiReqSagaCreator<SubmitParams, SubmitResult>(
      API_REQ_ACTION_TYPES.EXTERNAL.FORMS.SUBMIT,
      (data) => ({
        method: HTTP_METHODS.POST,
        url: ApiPaths.external.form.submit._(),
        data,
      })
    ),
    resend: apiReqSagaCreator<ResendParams, ResendResult>(
      API_REQ_ACTION_TYPES.EXTERNAL.FORMS.RESEND,
      (params) => ({
        method: HTTP_METHODS.POST,
        url: ApiPaths.external.form.byId.resend._({
          [ApiUrlParams.externalFormId]: params[ApiUrlParams.externalFormId],
        }),
      })
    ),
  },
  uploadFile: apiReqSagaCreator<UploadFileParams, UploadFileResult>(
    API_REQ_ACTION_TYPES.EXTERNAL.UPLOAD,
    (args) => ({
      method: HTTP_METHODS.POST,
      url: ApiPaths.external.form.uploadFile._({
        [ApiUrlParams.releaseOrDraftProcessId]:
          args[ApiUrlParams.releaseOrDraftProcessId],
        [ApiUrlParams.fieldId]: args[ApiUrlParams.fieldId],
      }),
      data: args.field,
      headers: {
        'Content-Type': CONTENT_TYPE.MULTIPART_FORMDATA,
        [externalAuthHeaderName]: args.token,
      },
      baseURL: documentServiceUrl as string,
    })
  ),
};

export default External;
